/*
  todo: refactor this component so it will work correctly with the latest swiper lib version
  right now needs to be hardcoded to 6.0.4
*/
import 'swiper/components/navigation/navigation.scss';

import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { BREAKPOINTS } from '../../../constants/breakpoints';

SwiperCore.use([Autoplay, Pagination, Navigation]);

const SuperscriptCarousel = ({ data }) => {
  return (
    <Swiper
      autoplay={{
        delay: 3000,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        waitForTransition: false,
      }}
      breakpoints={{
        [BREAKPOINTS.desktopXS]: {
          slidesPerView: 4,
        },
      }}
      loop
      navigation
      slidesPerView={2}
      spaceBetween={20}
    >
      {Object.values(data).map((profile) => {
        return (
          <SwiperSlide>
            <Link
              key={profile.name}
              className="superscript-profile-grid__anchor"
              to={profile.slug}
            >
              <div className="superscript-profile-grid__profile">
                <div className="superscript-profile-grid__profile-img">
                  <GatsbyImage alt={profile.name} image={profile.image} />
                </div>
                <h5 className="superscript-carousel__profile-name">
                  {profile.name}
                </h5>
              </div>
            </Link>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

SuperscriptCarousel.propTypes = {
  data: PropTypes.object,
};

export default SuperscriptCarousel;
